module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-tokai-2-21b153e468f378bf6dab624f0df9e2c8.png";